module.exports = __webpack_public_path__ + "img/icon-lk.46c63fb1.svg";